import { QueryParameters } from "@faire/web-api/api/product/subscribed/retailerToken/back-in-stock/get";
import { useQuery as useGetSubscribedBackInStockQuery } from "@faire/web-api/api/product/subscribed/retailerToken/back-in-stock/get-hooks";
import { useCallback, useEffect, useMemo, useState } from "react";

import { isBrandInRetailerView } from "@faire/retailer/lib/isBrandInRetailerView";
import { useRetailerStore } from "@faire/retailer/stores/domain/RetailerStore";

export const useSubscribedBackInStockToken = (productOptionToken: string) => {
  const [isSubscribedToBackInStock, setIsSubsribedToBackInStock] =
    useState<boolean>(false);

  const { retailerToken } = useRetailerStore(["retailerToken"]);

  const { data, isPending: isLoading } = useGetSubscribedBackInStockQuery(
    retailerToken ?? "",
    QueryParameters.build({
      product_option_tokens: [productOptionToken],
    })
  );

  const deleteBackInStockNotification = useCallback(
    (optionToken: string) => {
      setIsSubsribedToBackInStock(
        productOptionToken === optionToken ? false : true
      );
    },
    [productOptionToken]
  );

  useEffect(() => {
    if (!isLoading && !isBrandInRetailerView()) {
      setIsSubsribedToBackInStock(
        data?.product_option_tokens.includes(productOptionToken) ?? false
      );
    }
  }, [data?.product_option_tokens, isLoading, productOptionToken]);

  return useMemo(
    () => ({
      isSubscribedToBackInStock,
      deleteBackInStockNotification,
    }),
    [deleteBackInStockNotification, isSubscribedToBackInStock]
  );
};
